import type {
  BatchPersonRawRow,
  BatchPersonSummary,
  BatchPersonValidRow,
} from "./types";
import { validateBatchPersonRow } from "./validateBatchPersonRow";

function countFilledFields(row: BatchPersonValidRow): number {
  let filled = 0;
  if (row.cpf) filled += 1;
  if (row.name.trim()) filled += 1;
  if (row.gender) filled += 1;
  if (row.phone) filled += 1;
  if (row.birthDate) filled += 1;
  return filled;
}

/**
 * Monta o resumo. CPF repetido no arquivo: fica a linha com mais dados.
 */
export function buildBatchPersonSummary(
  rows: BatchPersonRawRow[],
  orgCpfs: Set<string>,
  usedFlexibleMapping: boolean,
): BatchPersonSummary {
  const invalid: BatchPersonSummary["invalid"] = [];
  const duplicates: BatchPersonSummary["duplicates"] = [];
  const byCpf = new Map<string, BatchPersonValidRow>();

  rows.forEach((raw) => {
    const validated = validateBatchPersonRow(raw);
    if (!validated.ok) {
      invalid.push({
        lineNumber: raw.lineNumber,
        name: raw.name.trim() || `Linha ${raw.lineNumber}`,
        reason: validated.reason,
      });
      return;
    }

    const current = validated.row;
    const previous = byCpf.get(current.cpf);
    if (!previous) {
      byCpf.set(current.cpf, current);
      return;
    }

    const previousScore = countFilledFields(previous);
    const currentScore = countFilledFields(current);
    if (currentScore > previousScore) {
      duplicates.push({
        lineNumber: previous.lineNumber,
        name: previous.name,
        reason: "CPF repetido",
      });
      byCpf.set(current.cpf, current);
      return;
    }

    duplicates.push({
      lineNumber: current.lineNumber,
      name: current.name,
      reason: "CPF repetido",
    });
  });

  const uniqueValid = Array.from(byCpf.values());

  return {
    toRegister: uniqueValid.filter((row) => !orgCpfs.has(row.cpf)),
    alreadyInOrg: uniqueValid.filter((row) => orgCpfs.has(row.cpf)),
    invalid,
    duplicates,
    usedFlexibleMapping,
  };
}
